import { Paper } from '@mui/material';
import React from 'react';

export const FilePreviewTable = ({ data }) => {
  const { columns, rows } = data;

  if (columns.length === 0) return null;

  return (
    <Paper
      elevation={3}
      style={{
        // margin: '0.5rem 0',
        padding: '1rem',
        // background: '#f1f3f5',
        // borderRadius: 8,
        maxWidth: '1250px',
        margin: '0 auto',
      }}
    >
      <strong>Pré-visualização do arquivo:</strong>
      <div style={{ overflowX: 'auto', marginTop: '0.5rem' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
          <thead>
            <tr>
              {columns.map((col, index) => (
                <th
                  key={index}
                  style={{
                    // border: '1px solid #ccc',
                    padding: '0.5rem',
                    // background: '#dee2e6',
                    textAlign: 'left',
                  }}
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.slice(0, 3).map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <td
                    key={colIndex}
                    style={{
                      borderTop: '1px solid #ccc',
                      padding: '1rem',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {row[col] ?? ''}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length > 3 && (
          <p style={{ fontSize: '0.8rem', marginTop: '0.5rem' }}>
            Exibindo as 3 primeiras linhas de {rows.length}.
          </p>
        )}
      </div>
    </Paper>
  );
};
